export default "__VITE_ASSET__875zVCxY__"